import React from "react";
import { VerseWidget } from "@/components/VerseWidget";
import { BirthdayWidget } from "@/components/BirthdayWidget";
import { CommonPointsWidget } from "@/components/CommonPointsWidget";
import { ContactsWidget } from "@/components/ContactsWidget";
import { PrayersSpotlightWidget } from "@/components/PrayersSpotlightWidget";
import { GoogleAd } from "@/components/GoogleAd";
import { useApp } from "@/context/AppContext";

// Widgets driven by the admin layout blocks (zone: right_sidebar).
export const RightSidebar = () => {
  const { config } = useApp();
  const blocks = (config?.layout_blocks || []).filter(b => b.zone === "right_sidebar" && b.visible && b.enabled).sort((a,b) => a.order - b.order);

  const renderBlock = (b) => {
    switch (b.key) {
      case "verse_of_day": return <VerseWidget key={b.key} />;
      case "common_points": return <CommonPointsWidget key={b.key} />;
      case "birthdays": return <BirthdayWidget key={b.key} />;
      case "contacts": return <ContactsWidget key={b.key} />;
      case "prayers_spotlight": return <PrayersSpotlightWidget key={b.key} variant="sidebar" />;
      default: return null;
    }
  };

  return (
    <div className="space-y-4" data-testid="right-sidebar">
      {blocks.map(renderBlock)}
      <GoogleAd slotKey="sidebar_slot" routeKey="sidebar" />
    </div>
  );
};
